import moment from "moment";
import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";

const ErrorsTrend = ({ errorlogDistribution }) => {
	const timelineLabels = useMemo(() => {
		let startX = errorlogDistribution.startX;
		let endX = errorlogDistribution.endX;
		let groupByPeriod = errorlogDistribution.groupByPeriod;
		let labels = [];
		while (startX < endX) {
			labels.push(moment(startX).format("HH:mm"));
			startX += groupByPeriod;
		}
		return labels;
	}, [errorlogDistribution]);

	const lineChartData = (chartData) => {
		return {
			labels: timelineLabels,
			datasets: [
				{
					data: chartData.values,
					borderWidth: 1,
					lineTension: 0,
					elements: { point: { radius: 1 } },
				},
			],
		};
	};

	return (
		<Bar
			data={lineChartData(errorlogDistribution)}
			options={{
				backgroundColor: "orange",
				borderColor: "black",
				color: "green",
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false,
					},
				},
			}}
		/>
	);
};

export default ErrorsTrend;
